<template>
  <div
    v-if="product"
    class="atom-click-and-collect-notice__wapper"
  >
    <div
      v-if="!product.is_sendable || forceClickAndCollect"
      class="atom-click-and-collect-notice"
      :class="
        [
          {
            'is-visible': visible || forceInfo,
            'is-filled': appereance === 'filled',
            'is-colored-outlined': (hasOutlines && isEditable || forceOutline),
            'show-in-color': showInColor,
          },
          activeColorClass,
        ]
      "

      @click="showInColor ? null : deliveryPopupStore.addProduct(product)"
      @keypress="showInColor ? null : deliveryPopupStore.addProduct(product)"
    >
      <AppIcon
        icon="click-n-collect-flag"
        :is-raw="true"
      />

      <p>{{ showInColor ? computedText : useTranslation('general', 'click_and_collect') }}</p>

      <AppIcon
        v-if="(forceInfo || clientStore.isDesktop) && !showInColor"
        icon="info"
        :is-raw="true"
      />
    </div>
    <div
      v-else
      class="atom-click-and-collect-notice no-link"
      :class="{
        'is-visible': visible || forceInfo,
        'is-filled': appereance === 'filled',
        'is-colored-outlined': (hasOutlines && isEditable || forceOutline),
        'color-primary': product?.deliveryTime?.key !== 'delivery_time_ah' && product?.deliveryTime?.key !== 'delivery_time_nl',
        'color-red': product?.deliveryTime?.key === 'delivery_time_ah',
        'color-red': product?.deliveryTime?.key === 'delivery_time_nl',
      }"
    >
      <AppIcon
        icon="truck"
        :is-raw="true"
      />

      <p>
        {{ useTranslation('general', product.deliveryTime?.key || 'delivery_time_2') }}
        <!-- {{ useTranslation('general', product.deliveryTime?.key === 'delivery_time_ah'
          ? 'delivery_time_0'
          : product.deliveryTime?.key)
        }} -->
      </p>
    </div>
    <div
      v-if="!disableAvailability && product.is_sendable && !forceClickAndCollect"
      class="atom-click-and-collect-notice"
      :class="
        [
          {
            'is-visible': visible || forceInfo,
            'is-filled': appereance === 'filled',
            'is-colored-outlined': hasOutlines && isEditable,
            'show-in-color': showInColor,
          },
          activeColorClass,
        ]
      "

      @click="showInColor ? null : availabilityPopupStore.addProduct(product)"
      @keypress="showInColor ? null : availabilityPopupStore.addProduct(product)"
    >
      <AppIcon
        icon="click-n-collect-flag"
        :is-raw="true"
      />

      <p>{{ showInColor ? computedText : useTranslation('general', 'availability') }}</p>

      <AppIcon
        v-if="(forceInfo || clientStore.isDesktop) && !showInColor"
        icon="info"
        :is-raw="true"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
    visible: {
        type: Boolean,
        required: true,
    },

    disableAvailability: {
        type: Boolean,
        default: false,
    },

    appereance: {
        type: String,
        default: 'default', // default || filled
    },

    forceInfo: {
        type: Boolean,
        default: false,
    },

    forceClickAndCollect: {
        type: Boolean,
        default: false,
    },

    forceOutline: {
        type: Boolean,
        default: false,
    },

    hasOutlines: {
        type: Boolean,
        default: false,
    },
    store: {
        type: Object,
        default: () => {},
    },

    forceAvailable: {
        type: Boolean,
        default: false,
    },

    product: {
        type: Object,
        default: null,
    },
});

/*
  Injected Data
*/
const product = inject('product', props.product);

/*
  Store
*/
const clientStore = useClientDeviceStore();
const deliveryPopupStore = useDeliveryPopupStore();
const availabilityPopupStore = useAvailabilityPopupStore();

/*
  Locked State
*/
const isEditable = inject('is-editable', null);

/*
  Checked pharmacy
*/
const checkoutStore = useCheckoutStore();
const checkedPharmacy = computed(() => checkoutStore.getActivePharmacy);

const cartStore = useCartStore();
const route = useRoute();
const showInColor = computed(() => {
    if (cartStore.isClickAndCollect && route.path.includes('warenkorb/adresse')) {
        return true;
    }
    return false;
});

const activeColorClass = computed(() => {
    if (!showInColor.value) return '';
    const baseLine = cartStore.getProductQuantity(product) || 0;
    const mainStore = product.stocks?.find((s) => s?.store?.id === 14);
    const pharmacy = product.stocks?.find((s) => s?.store?.id === checkedPharmacy.value);

    const quantity = pharmacy?.quantity || 0;

    if (quantity >= baseLine) return 'colored-available';
    if (mainStore?.quantity >= baseLine) return 'colored-medium-available';
    return 'not-available';
});

const computedText = computed(() => {
    if (props.forceAvailable) {
        return useTranslation('general', 'click_and_collect_1');
    }

    switch (activeColorClass.value) {
    case 'colored-available':
        return useTranslation('general', 'click_and_collect_1');
    case 'colored-medium-available':
        return useTranslation('general', 'click_and_collect_2');
    case 'not-available':
        return useTranslation('general', 'click_and_collect_3');
    default:
        return '';
    }
});
</script>

<style lang="scss">
.atom-click-and-collect-notice__wapper {
    display: flex;
    column-gap: 10px;
    row-gap: 10px;

    @include mobile {
        flex-direction: column;
    }
}

.atom-click-and-collect-notice {
    @include typo-font('regular');
    @include typo-size('button');
    @include fluid('padding-left', 12px, 18px);
    @include fluid('padding-right', 12px, 18px);
    @include fluid('padding-top', 3px, 15px);
    @include fluid('padding-bottom', 3px, 15px);
    @include fluid('column-gap', 6px, 10px);
    @include z-index('main');

    display: flex;
    height: 58px;
    flex-wrap: nowrap;
    align-items: center;
    border: 2px solid $C_GREEN_DARK;
    border-radius: 6px;
    color: $C_GREEN_DARK;
    cursor: pointer;
    opacity: 0;
    pointer-events: none;
    white-space: nowrap;

    svg {
        width: 24px;

        path {
            fill: $C_GREEN_DARK;
        }
    }

    &.no-link {
        cursor: default;

        svg {
            fill: $C_GREEN_DARK;
        }
    }

    &.color-primary {
        p, path {
            color: $C_PRIMARY;
            fill: $C_PRIMARY;
        }

        &.is-colored-outlined {
            border-color: $C_PRIMARY;
        }
    }

    &.color-olive {
        p, path {
            color: $C_GREEN_OLIVE;
            fill: $C_GREEN_OLIVE;
        }

        &.is-colored-outlined {
            border-color: $C_GREEN_OLIVE;
        }
    }

    &.color-orange {
        p, path{
            color: $C_ORANGE_STRONG;
            fill: $C_ORANGE_STRONG;
        }

        &.is-colored-outlined {
            border-color: $C_ORANGE_STRONG;
        }
    }

    &.color-red {
        p, path{
            color: $C_RED_PRIMARY;
            fill: $C_RED_PRIMARY;
        }

        &.is-colored-outlined {
            border-color: $C_RED_PRIMARY;
        }
    }

    &.is-filled {
        border: none;
        background: $C_WHITE;
        color: $C_WHITE;
        color: $C_GREEN_DARK;
    }

    .shop-cart-list__column & {
        margin-top: auto;
        margin-bottom: auto;

        @include tablet {
            display: flex;
            width: 100%;
            height: auto;
            align-self: baseline;
            justify-content: center;
            order: 4;
            margin-top: unset;
            margin-right: 0;
            margin-bottom: unset;
        }
    }

    &.is-visible {
        opacity: 1;
        pointer-events: all;
    }

    &:not(.is-visible) {
        @include mobile {
            display: none;
        }
    }

    &.show-in-color {
        cursor: default;

        &.colored-available {
            border-color: $C_PRIMARY;
            color: $C_PRIMARY;

            path {
                fill: $C_PRIMARY !important;
            }
        }
        &.colored-medium-available {
            border-color: $C_GREEN_OLIVE_LIGHT;
            color: $C_GREEN_OLIVE_LIGHT;

            path {
                fill: $C_GREEN_OLIVE_LIGHT !important;
            }
        }
        &.not-available {
            border-color: $C_ORANGE_STRONG;
            color: $C_ORANGE_STRONG;

            path {
                fill: $C_ORANGE_STRONG !important;
            }
        }
    }

}
</style>
